// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { generateId } from '../../_common/api/utility';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import LoyaltyCard from '../LoyaltyCard';
import HomeCard from '../HomeCard';

const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    padding: 0 1.5em 0.7em 1.5em;
    justify-content: space-between;
    animation: slideInFromRight 0.3s;

    gap: 0.5em;
`

const Home = ({ ...props }) => {
    const {
        state: {
            site_config,
        },
    } = useGlobalState();

    return (
        <Col>
            {site_config.loyaltyProgram ? <LoyaltyCard /> : null}
            {
                site_config.homeCards.map((e, i) =>
                    <HomeCard
                        key={generateId()}
                        index={i}
                        to={e.to}
                        text={e.text}
                        icon={e.icon}
                    />
                )
            }
        </Col>
    );
}

export default Home;